// 自定义指令-列拖拽
// 需要依赖 sortablejs

/*+
** v-dragColumns="{ columns: [] }"
+*/
import Sortable from "sortablejs";
let sortable = null;
export function registerCustomDirectivesDragColumns(app) {
    let options = {
		mounted(el, binding) {
			handlerListener(el, binding, 'add')
		},
		updated(el, binding) {
			handlerListener(el, binding, 'updated')
		},
		unmounted(el, binding) {
			handlerListener(el, binding, 'remove')
		}
	}
    app.directive("dragColumns", options);
}

function handlerListener(el, binding, mod) {
	try {
		sortable.destroy();
	} catch (e) { }
	if (mod !== 'remove') {
		// columnDrop(el, binding, deepClone(binding.value.columns))
		columnDrop(el, binding, binding.value.columns)
	}
}

/**
 * 列拖拽
 */
function columnDrop(el, binding, columns) {
	// 兼容element-ui 的 el-table / element-plus 的 el-table-v2
	let wrapperTr = null;
	wrapperTr = el.querySelector(".el-table__header-wrapper tr"); // el-table
	if (!wrapperTr) {
		wrapperTr = el.querySelector(".el-table-v2__header .el-table-v2__header-row.el-table-v2__dynamic-header-row"); // el-table-v2
	}
	if (!wrapperTr) {
		return
	}
	sortable = Sortable.create(wrapperTr, {
		animation: 180,
		delay: 0,
		onEnd: (evt) => {
			// return
			// 跳过显示的列数量
			const empty = (binding.value.empty || {}).value || binding.value.empty || 0; // 兼容Vue3、Vu2

			const oldItem = columns[evt.oldIndex - empty];
			columns.splice(evt.oldIndex - empty, 1);
			columns.splice(evt.newIndex - empty, 0, oldItem);
			// console.log(columns, 'columns')
		},
	});
}

/**
 * 触发表格重绘
 */
function reDrawer() {
	columnDrop();
}
